import { InvalidLengthError } from "../errors/index.js";
import { SIZE } from "./constants.js";

/**
 * Create Hash from raw bytes
 *
 * @see https://voltaire.tevm.sh/primitives/hash for Hash documentation
 * @since 0.0.0
 * @param {Uint8Array} bytes - Raw bytes (must be 32 bytes)
 * @returns {import('./HashType.js').HashType} Hash bytes
 * @throws {InvalidLengthError} If bytes is wrong length
 * @example
 * ```javascript
 * import * as Hash from './primitives/Hash/index.js';
 * const hash = Hash.fromBytes(new Uint8Array(32));
 * ```
 */
export function fromBytes(bytes) {
	if (bytes.length !== SIZE) {
		throw new InvalidLengthError(
			`Hash must be ${SIZE} bytes, got ${bytes.length}`,
			{
				code: -32602,
				value: bytes,
				expected: `${SIZE} bytes`,
				context: { actualLength: bytes.length },
				docsPath: "/primitives/hash",
			},
		);
	}
	return /** @type {import('./HashType.js').HashType} */ (
		new Uint8Array(bytes)
	);
}
